const STYLES = {
  low: "bg-[#E6F0EB] text-[#34745C]",
  medium: "bg-[#FDF3E1] text-[#C48231]",
  high: "bg-[#FCEAE8] text-[#B54D40]",
};

export const RiskBadge = ({ level }) => {
  if (!level) return null;
  return (
    <span
      data-testid={`risk-badge-${level}`}
      className={`${STYLES[level] || STYLES.medium} px-2.5 py-0.5 rounded-full text-xs font-semibold uppercase tracking-wider whitespace-nowrap`}
    >
      {level} risk
    </span>
  );
};

export const DocTypeBadge = ({ type }) => {
  if (!type) return null;
  return (
    <span className="bg-[#F9F7F4] border border-[#E8E6E1] text-[#57605A] px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap">
      {type}
    </span>
  );
};

export const ReviewBadge = ({ status }) => {
  const map = {
    pending: "bg-[#FDF3E1] text-[#C48231]",
    verified: "bg-[#E6F0EB] text-[#2E5C50]",
    rejected: "bg-[#FCEAE8] text-[#B54D40]",
  };
  return (
    <span
      data-testid={`review-badge-${status}`}
      className={`${map[status] || map.pending} px-2.5 py-0.5 rounded-full text-xs font-semibold uppercase tracking-wider whitespace-nowrap`}
    >
      {status}
    </span>
  );
};
